import { LeaderboardEntry, MatchResult } from '../types';

// Point this at your deployed Worker URL in production, e.g.
// "https://target-rush-backend.<your-subdomain>.workers.dev"
const API_BASE = import.meta.env.VITE_API_BASE || 'http://localhost:8787';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data.error || `Request failed with status ${res.status}`);
  }
  return data as T;
}

export async function registerUsername(
  username: string
): Promise<{ userId: string; username: string; token: string }> {
  return request('/api/register', {
    method: 'POST',
    body: JSON.stringify({ username }),
  });
}

export async function startSession(
  token: string,
  weaponId: string,
  mapId: string,
  mode: string
): Promise<{ sessionId: string; serverStartedAt: number }> {
  return request('/api/session/start', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ weaponId, mapId, mode }),
  });
}

export async function submitScore(
  token: string,
  sessionId: string,
  result: MatchResult
): Promise<{ accepted: boolean; scoreId: string; coinsEarned: number }> {
  return request('/api/session/submit', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({
      sessionId,
      score: result.score,
      shots: result.shots,
      hits: result.hits,
      durationSeconds: result.durationSeconds,
    }),
  });
}

export async function fetchLeaderboard(
  period: 'alltime' | 'daily' | 'weekly' = 'alltime'
): Promise<{ entries: LeaderboardEntry[] }> {
  return request(`/api/leaderboard?period=${period}`);
}
